import Grid from '@mui/material/Grid'
import { useFormContext } from 'react-hook-form'
import { UniOption } from '../../../dao/UniOption'
import { Is連動排除的題目, UniQuestion } from '../../../dao/UniQuestion'
import { new_ErrorAlert } from '../../../export_spwk/ExportManager'
import { useGV } from '../../../GV'
import UcQuestion from './UcQuestion'
import { Member } from '../../../dao/Member'

type Props = {
  questions: UniQuestion[] | undefined,
  member: Member | null | undefined,
}
//Panel 容器放 question list
const UcQuestionPanel = ({ questions, member }: Props) => {

  const GV = useGV();

  const rhf = useFormContext();

  function product_question_list(questions: UniQuestion[] | undefined) {
    if (questions === undefined) {
      return
    }

    return questions.map((question: UniQuestion) => {
      if (question.Options === undefined) {
        throw new_ErrorAlert("64646521 question.Options === undefined !!!");
      }

      let options: UniOption[] = question.Options;

      let is_lock = Is連動排除的題目(question, rhf);// 是否 Hide 或 Disabled 這題

      if (is_lock) {
        if (GV.IsAdmin()) {
          return (
            <Grid item xs={12} key={question.guid} sx={{ bgcolor: '#FFAAAA' }}>
              <UcQuestion question={question} options={options} member={member} />
            </Grid>
          )
        } else {
          return undefined;
        }

      } else {
        return (
          <Grid item xs={12} key={question.guid}>
            <UcQuestion question={question} options={options} member={member} />
          </Grid>
        )
      }

    })
  }

  return (
    <Grid container rowSpacing={{ xs: 3 }}>
      {product_question_list(questions)}
    </Grid>
  )
}

export default UcQuestionPanel